import Vue from "vue";
import Vuex from "vuex";
import { Stats } from "fs";

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    timeGap: "",
    contactType: null,
    showLoginPad: null,
    headerSign: "",
    command: "sc",
    conty: "zh-cn",
    showRegi: false,
    // goodsInfo: '',
    cartflag: null,
    // temp: null,
    showFooter: true,
    cartFlag: null
  },
  mutations: {
    changeCType(state, val) {
      state.contactType = val;
    },
    changeShowLogin(state, val) {
      state.showLoginPad = val;
    },
    setTimeGap(state, val) {
      state.timeGap = val;
    },
    setHeader(state, val) {
      state.headerSign = val;
    },
    changeLanguage(state, val) {
      state.command = val;
    },
    changeConty(state, val) {
      state.conty = val;
    },
    changeRegi(state, val) {
      state.showRegi = val;
    },
    // setGoods(state, val) {
    //     state.goodsInfo = val
    // },
    setFlag(state, val) {
      state.cartflag = val;
    },
    // setTemp(state, val) {
    //     state.temp = val
    // },
    setFo(state, val) {
      state.showFooter = val;
    },
    setCartFlag(state, val) {
      state.cartFlag = val;
    }
  },
  action: {}
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js